/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_PlanInputs */

const en_st_mock_plan = /** @type {(inputs: St_Mock_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member app · phase 2 of 4`)
};

const id_st_mock_plan = /** @type {(inputs: St_Mock_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikasi anggota · fase 2 dari 4`)
};

/**
* | output |
* | --- |
* | "Member app · phase 2 of 4" |
*
* @param {St_Mock_PlanInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_plan = /** @type {((inputs?: St_Mock_PlanInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_PlanInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_plan(inputs)
	return en_st_mock_plan(inputs)
});